import React, { Component }  from 'react';
import Specimens from '../specimens-list/specimens-list';
import Loading from '../loading';

import InternalService from '../../services/internal-api';
import './indefinable.css';

export default class Indefinable extends Component {

  stampsData = new InternalService();

  state = {
    showType: null,
    loading: true
  };

  componentDidMount() {    
    this.stampsData.getIndefinableSpecimens()
      .then((body) => {
        this.setState({
          showType: body.data,
        });
      });
      this.setState({loading: false});
  }

  renderLiteratureSums(arr) {
    return arr.map(({name, val}) => {
      return (
        <div key={name}>
          <span className="date">{name}</span> : {val}
          <br /> <br />
        </div>
      );
    });
  }

  render() {

    const { showType } = this.state;
    if (!showType) {
      return (
        <Loading />
      )
    }

    let items, itemsHeader, panelClass;

    items = (<Specimens items={showType} showControls={false} />);
    itemsHeader = (<div className="footer-widget-heading"><h3>Known specimens</h3></div>);
    panelClass = "items";


    let arrLiterature = [];
    showType.map( 
      (currentValue) => { 
        const found = arrLiterature.find(el => (el.name === currentValue.name || currentValue.name === null));
        if (!found) {
          arrLiterature.push({name: currentValue.name ? currentValue.name : 'Unpublished', val: 1});
        }
        else found.val+=1;
      }
    );
    const literatureSums = this.renderLiteratureSums(arrLiterature);

    return (
      <div className="main-grid">
        <div className="footer-widget-heading padding-left">
          <h3>Неопределенные экземпляры</h3>
          {literatureSums}
        </div>
        <div>
          {itemsHeader}
          <div className={panelClass}>
            {items}
          </div>
        </div>
      </div>
    )
  }
}
